export const PAYWALL_MODE = {
  main: 'DEFAULT',
  chosenPayway: 'CHOSEN_PAYWAY',
  regulationsApproval: 'REGULATIONS_APPROVAL',
}

export const PAYWALL_PAYWAY_METHOD = {
  single: 'SINGLE',
  auto: 'AUTO',
}

export const PAYWALL_THEME = {
  light: 'light',
  dark: 'dark',
  contrast: 'contrast',
}

export const PAYWALL_THEME_LIST = [PAYWALL_THEME.light, PAYWALL_THEME.dark, PAYWALL_THEME.contrast]

// `contrast` jest ROZSZERZENIEM `dark`, nie osobną paletą: DOM dostaje obie klasy (`dark contrast`),
// a widget kart obie flagi (`darkMode=true&contrastMode=true`). Ta lista jest źródłem prawdy dla
// wszystkich miejsc, które pytają „czy motyw jest ciemny" — nie porównuj z `PAYWALL_THEME.dark`
// wprost, bo tryb contrast wypadnie z ciemnej gałęzi i wstanie jasny albo pomarańczowy.
export const PAYWALL_THEME_DARK_LIST = [PAYWALL_THEME.dark, PAYWALL_THEME.contrast]

export const THEME_CONTEXT_SUPPORT_LIST = ['orangedoppayment', 'njumobile']

// Tryb contrast (dark + żółty akcent) ma dziś tylko Orange DOP. Kontekst z motywem, ale bez
// contrastu, degraduje `?layout=contrast` do `dark` — patrz `useApp.setPageTheme`.
export const CONTRAST_CONTEXT_SUPPORT_LIST = ['orangedoppayment']
